import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IPackagesApi } from "@/api/packages";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { PlanSettings } from "@/models/package";
import { useToast } from "@/hooks/use-toast";

export const useOrganizationPlan = (organizationId: string) => {
  const packagesApi = useInjection<IPackagesApi>(SERVICES_TYPES.PACKAGES);

  return useQuery({
    queryKey: ["organization-plan", organizationId],
    queryFn: () => packagesApi.getOrganizationPlan(organizationId),
    enabled: !!organizationId
  });
};

export const useUpdateOrganizationPlan = (organizationId: string) => {
  const packagesApi = useInjection<IPackagesApi>(SERVICES_TYPES.PACKAGES);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (plan: PlanSettings & { package: string | null }) =>
      packagesApi.updateOrganizationPlan(organizationId, plan),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organization-plan", organizationId] });
      toast({
        title: "Plan saved",
        description: "Members see the change on their next page load."
      });
    },
    onError: (error) => {
      toast({ title: "Failed to save plan", description: error.message, variant: "destructive" });
    }
  });
};
